// COPY NUEVO PA-3 — literales de pa3-textos.md, pendientes de aprobación de Jesús.
export const COPY_PA3 = {
  titulo: "Prueba gratis de Surit Clínicas",
  bajada: "7 días o 100 conversaciones con Sofi, lo que pase primero. Empiezan cuando conectes tu WhatsApp.",
  clinica: "Nombre de la clínica", nombre: "Tu nombre", correo: "Correo electrónico",
  telefono: "Teléfono (10 dígitos de México)", plan: "Plan con Sofi",
  planes: { "consultorio-sofi": "Consultorio — con Sofi", "clinica-sofi": "Clínica — con Sofi" },
  enviar: "Pedir mi prueba gratis",
  enviado: "Te enviamos un correo para que crees tu contraseña y continúes.",
  espera: "Solicitud en revisión",
  esperaDetalle: "Ya puedes configurar tu clínica. Te avisaremos por correo cuando puedas conectar WhatsApp.",
  aprobada: "Prueba aprobada", aprobadaDetalle: "Conecta tu WhatsApp para empezar tus 7 días.",
  rechazada: "No pudimos aprobar tu prueba gratis",
  rechazadaDetalle: "Puedes elegir un plan o escribirnos a soporte@surit.ai.",
  numeroUsado: "Este número de WhatsApp ya tuvo una prueba gratis. Elige un plan para usar Sofi.",
  datos: "Revisa los datos del formulario.", eligePlan: "Elige un plan con Sofi.",
  duplicada: "Ya se pidió una prueba gratis con estos datos.",
  error: "No pudimos completar tu solicitud. Inténtalo de nuevo.",
  limite: "Hiciste varias solicitudes seguidas. Inténtalo más tarde.",
  configurar: "Configura tu clínica", medicos: "Médicos", sofi: "Sofi", whatsapp: "WhatsApp",
  // Paso de confirmación (cuenta que ya existía): textos aprobados por Jesús el 25 Oct 2026.
  confirmarTitulo: "Confirma tu prueba gratis",
  confirmarDetalle: "Pediste una prueba gratis para esta clínica con una cuenta que ya tenías. Confírmala para empezar a configurarla.",
  confirmar: "Confirmar mi prueba gratis",
  // Una prueba por persona: textos aprobados por Jesús el 25 Oct 2026.
  clienteTitulo: "Esta cuenta ya usa Surit Clínicas",
  clienteDetalle: "La prueba gratis es una por persona y tu cuenta ya la usó o ya tiene un plan. Para esta clínica, contrata su plan.",
  clienteContratar: "Contratar el plan de esta clínica",
};

export function permisosPrueba(user) {
  const p = user?.plan_vigente;
  return user?.prueba_clinicas_autoservicio === true &&
    [p?.puede_configurar, p?.puede_conectar, p?.puede_operar].every(x => typeof x === "boolean") ? p : null;
}
